import { Fragment } from 'react/jsx-runtime'
import {
  booking,
  cancelledBookings,
  totalBus,
  totalEarnings,
  totalLocations,
  totalProviders,
  totalusers,
} from '@assets/icons'
import { recentProvidersColumn, recentUsersColumn } from './column'
import Column from '@components/column'
import DashboardCard from '@commons/cards/dashboard'
import useIsMobile from '@hooks/useIsMobile'
import ActiveBookings from '@commons/bookings/active'
import Users from '@commons/users'

const Dashboard = () => {
  const cardConfig = [
    {
      key: 'totalVehicles',
      title: 'Total Buses',
      icon: totalBus,
      isUp: true,
      // link: '/admin/',
    },
    {
      key: 'totalBookings',
      title: 'Total Bookings',
      icon: booking,
      isUp: true,
      link: '/admin/bookings',
    },
    {
      key: 'totalActiveBooking',
      title: 'Active Bookings',
      icon: booking,
      isUp: false,
      link: '/admin/bookings?tab=Active%20Bookings',
    },
    {
      key: 'totalCompletedBooking',
      title: 'Completed Bookings',
      icon: booking,
      isUp: false,
      link: '/admin/bookings?tab=Completed%20Bookings',
    },
    {
      key: 'totalCancelledBooking',
      title: 'Cancelled Bookings',
      icon: cancelledBookings,
      isUp: false,
      link: '/admin/bookings?tab=Cancelled%20Bookings',
    },
    {
      key: 'totalRoutes',
      title: 'Total Locations',
      icon: totalLocations,
      isUp: false,
      link: '/admin/location-setup',
    },
    {
      key: 'totalProviders',
      title: 'Total Providers',
      icon: totalProviders,
      isUp: false,
      link: '/admin/user-management/providers',
    },
    {
      key: 'totalRevenue',
      title: 'Total Earnings',
      icon: totalEarnings,
      isUp: false,
      link: '/admin/transactions',
    },
  ]
  const isMobile = useIsMobile()
  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <ActiveBookings />
        <Users
          title={'Recent Users'}
          icon={totalusers}
          columns={recentUsersColumn}
          isInDashboard={true}
        />
        <Users
          title={'Recent Providers'}
          icon={totalProviders}
          columns={recentProvidersColumn}
          isInDashboard={true}
          role={'operator'}
        />
      </Column>
    </Fragment>
  )
}
export default Dashboard
